module.exports = __webpack_public_path__ + "img/2taskStatus.a1ff8e63.svg";